// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5e-0";
export var startPickingButton = "_5e-1";